module.exports = require('./assignInWith');